import { TestEvent, TestEventStatus } from "@/api/williams/testEvents";

const StatusText: Record<number, string> = {
  [TestEventStatus.New]: "New",
  [TestEventStatus.Partial]: "Partial",
  [TestEventStatus.Initiated]: "Initiated",
  [TestEventStatus.NoTestResults]: "No test results",
  [TestEventStatus.PartialTestResults]: "Partial test results",
  [TestEventStatus.Completed]: "Completed",
  [TestEventStatus.Old]: "Old",
  [TestEventStatus.OldWithTestResults]: "Old with test results",
  [TestEventStatus.Cancelled]: "Cancelled",
};

export function getStatusText(status: TestEventStatus) {
  return StatusText[status];
}

export function getTestEventStatus(testEvent: TestEvent) {
  if (testEvent.status === TestEventStatus.Cancelled) {
    return testEvent.status;
  }

  if (testEvent.project === null) {
    return TestEventStatus.New;
  } else if (testEvent.welders.length === 0) {
    return TestEventStatus.Partial;
  } else if (testEvent.welderTests.length === 0) {
    return TestEventStatus.Initiated;
  } else if (testEvent.welderTests.every((x) => x.submitted === false)) {
    return TestEventStatus.NoTestResults;
  } else if (testEvent.welderTests.every((x) => x.submitted === true)) {
    return TestEventStatus.Completed;
  } else if (testEvent.welderTests.some((x) => x.submitted === true)) {
    return TestEventStatus.PartialTestResults;
  } else {
    return testEvent.status;
  }
}
